import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { HotelSlider } from './HotelSlider';
import ChatMessage from './ChatMessage';
import { LOADING } from '../utils/constants';
import { LoadingComponent } from './LoadingComponent';

export const ChatDisplay = ({
  messageArray, conversationApiStatus, loadingStep,
  appendErrorMessage, scrollToBottom,
}) => {
  const [typedMessageIds, setTypedMessageIds] = useState(() => new Set());

  const handleTypingComplete = useCallback((messageId) => {
    setTypedMessageIds((prev) => {
      if (prev.has(messageId)) return prev;

      const next = new Set(prev);
      next.add(messageId);
      return next;
    });
  }, []);

  return (
    <div
      className="flex flex-column flex-justify-start pad-2-t"
    >
      {messageArray.map(({
        id, isSentByUser, message, type, hotels, pulseAt,
      }) => {
        if (type === 'hotels') {
          return typedMessageIds.has(id - 1) ? (
            <HotelSlider
              key={id}
              id={id}
              hotels={hotels}
              appendErrorMessage={appendErrorMessage}
            />
          ) : null;
        }

        return (
          <ChatMessage
            key={id}
            id={id}
            isSentByUser={isSentByUser}
            message={message}
            pulseAt={pulseAt}
            onTypingComplete={handleTypingComplete}
            scrollToBottom={scrollToBottom}
          />
        );
      })}
      {conversationApiStatus === LOADING && (
        <LoadingComponent loadingStep={loadingStep} />
      )}
    </div>
  );
};

ChatDisplay.propTypes = {
  messageArray: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  conversationApiStatus: PropTypes.string.isRequired,
  loadingStep: PropTypes.string.isRequired,
  appendErrorMessage: PropTypes.func.isRequired,
  scrollToBottom: PropTypes.func.isRequired,
};
